import { Pipe, PipeTransform } from '@angular/core';

enum FileType {
    Undefinded = 'icons-jms icon-jms-type-file',
    Word = 'icons-jms icon-jms-type-word',
    Excel = 'icons-jms icon-jms-type-excel',
    PDF = 'icons-jms icon-jms-type-pdf',
    Other = 'icons-jms icon-jms-type-file'
}

@Pipe({
    name: 'fileSymbol',
    standalone: true
})
export class FileSymbolPipe implements PipeTransform {

    typeWordList = ['doc', 'docx'];
    typeExcelList = ['xls', 'xlsx', 'xlsm'];
    otherFileList = ['txt', 'xml'];
    pdf = ['pdf', 'PDF'];
    msg = ['msg'];

    transform(path: string): string {
        if (!path) return FileType.Undefinded;

        return this.handlePathValue(path);
    }

    private handlePathValue(path: string) {
        const fileName: string = path.replace(/^.*[\\\/]/, '');
        const nameAndType: string[] = fileName.split('.');

        if (nameAndType) {

            if (this.typeWordList.indexOf(nameAndType[1]) >= 0) {

                return FileType.Word;
            } else if (this.typeExcelList.indexOf(nameAndType[1]) >= 0) {

                return FileType.Excel;
            } else if (this.msg.indexOf(nameAndType[1]) >= 0) {

                return FileType.Other;
            } else if (this.pdf.indexOf(nameAndType[1]) >= 0) {

                return FileType.PDF;
            } else if (this.otherFileList.indexOf(nameAndType[1]) >= 0) {

                return FileType.Other;
            }

        }

        return FileType.Undefinded;
    }

}
